import { css } from 'lit';
export const dropDownStyles = css `
    ep-label,
    div.value {
        position: absolute;
        left: 0;
        transform: translateY(-50%);
    }
    ep-label {
        top: 0;
        --ep-label-text-font-size: var(--ep-dropdown-label-font-size, 14px);
        padding: 0 10px;
    }

    ep-label:not(.value) {
        top: 50%;
    }

    ep-label.value {
        display: var(--ep-dropdown-label-display, 'block');
        left: var(--ep-dropdown-label-left, 3px);
        top: var(--ep-dropdown-label-top, -2px);
    }

    .body {
        border-top: none;
        word-wrap: break-word;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
    }

    div.value {
        top: 50%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
//# sourceMappingURL=syles.js.map